import Helper from '../helpers/helper'
import filesize from 'filesize'

const FeatureValue = ({ feature, userRanges, users, setUsers, plan, variant }) => {
  switch (feature.kind) {
    case 'users':
      return (
        <strong>
          {userRanges.length == 1 && userRanges[0][0] == userRanges[0][1] ? (
            userRanges[0][0]
          ) : (
            <div className="pricing-select-wrapper">
              <select className="pricing-select" onChange={(e) => setUsers(e.target.value)} value={users}>
                {userRanges.map((i) => (
                  <option key={i[0]} value={i[0]}>
                    {i[0] == i[1] ? i[1] : i[1] ? i.join(` ${I18n.t('to-2')} `) : i.join(' +')}
                  </option>
                ))}
              </select>
              <i className="fa-solid fa-caret-down"></i>
            </div>
          )}
        </strong>
      )
    case 'limits_objects':
      return (
        <strong>{variant['limits_objects'] || plan.limits_objects || Helper.capitalize(I18n.t('unlimited'))}</strong>
      )
    case 'fixed':
      return <i className="fal fa-check"></i>
    case 'private_cloud':
      return plan.private_cloud ? <i className="fal fa-check"></i> : <span>&nbsp;</span>
    case 'api':
      if (!variant?.limits_api_calls && !plan.limits_api_calls) {
        return <strong>{Helper.capitalize(I18n.t('unlimited'))}</strong>
      }
      return (
        <>
          <strong>
            {(variant?.limits_api_calls && variant?.limits_api_calls?.toLocaleString(I18n.locale)) ||
              (plan.limits_api_calls && plan.limits_api_calls?.toLocaleString(I18n.locale)) ||
              Helper.capitalize(I18n.t('unlimited'))}
          </strong>{' '}
          <span className="unit">
            {`${I18n.t('api-request-count', {
              count: variant['limits_api_calls'] || plan.limits_api_calls || 99
            })}/${I18n.t('month-count', { count: 1 })}`}
          </span>
        </>
      )
    case 'storage':
      return variant['limits_data'] || plan.limits_data ? (
        <>
          <strong>{filesize((variant['limits_data'] || plan.limits_data) * 1.0e9, { output: 'object' }).value}</strong>{' '}
          <span className="unit">
            {filesize((variant['limits_data'] || plan.limits_data) * 1.0e9, { output: 'object' }).symbol}
          </span>
        </>
      ) : (
        <strong>{Helper.capitalize(I18n.t('unlimited'))}</strong>
      )
    case 'consultation':
      return plan.starting_consultation && plan.starting_consultation != '0' ? (
        <i className="fal fa-check"></i>
      ) : (
        <span>&nbsp;</span>
      )
    case 'automation':
      return (
        <>
          {variant['limits_workflow_causes'] || plan.limits_workflow_causes ? (
            I18n.t('pricing.limited')
          ) : <i className="fal fa-check"></i>}
        </>
      )
    case 'automation-old':
      return (
        <>
          <strong>
            {variant['limits_workflow_causes'] || plan.limits_workflow_causes || Helper.capitalize(I18n.t('unlimited'))}
          </strong>{' '}
          {variant['limits_workflow_causes'] || plan.limits_workflow_causes ? (
            <span className="unit">
              {I18n.t('process-count', {
                count: variant['limits_workflow_causes'] || plan.limits_workflow_causes || 99
              })}
            </span>
          ) : null}
        </>
      )
  }

  return <></>
}

export default FeatureValue
